import { Component, h, tag } from "omi";

import { NWLoadingSpinner } from "@/components/nw-loadingspinner";
import { NWSuspense } from "@/components/utility";
import { tailwind } from "@/tailwind";

import { installNWQuiz } from "./install";

type Props = {};

@tag("nw-quiz")
export class NWQuizEntry extends Component<Props> {
  static css = [tailwind];

  render() {
    return (
      <NWSuspense
        loadFunc={installNWQuiz}
        onLoadComplete={NWQuizApp => <NWQuizApp />}
        loadingComponent={() => <QuizSkeletonContainer />}
      />
    );
  }
}

function QuizSkeletonContainer() {
  return (
    <div className="relative bg-[#0C0E12] rounded-3xl px-8 py-16 min-h-96 flex items-center justify-center">
      <NWLoadingSpinner color="white" />
    </div>
  );
}
